import React from "react";
import LegalPageLayout from "@/legal/LegalPageLayout";
import { OPERATOR, BRAND } from "@/legal/legalConfig";

export default function Privacy() {
  return (
    <LegalPageLayout title="Datenschutzerklärung" lastUpdated="08.02.2026" testid="privacy-page">
      <h2>1. Verantwortliche Stelle</h2>
      <p>
        Verantwortlich für die Verarbeitung personenbezogener Daten im Sinne der DSGVO ist:
        <br /><br />
        <strong>{OPERATOR.legal_name}</strong><br />
        {OPERATOR.street}<br />
        {OPERATOR.zip} {OPERATOR.city}<br />
        E-Mail: <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>
      </p>

      <h2>2. Verarbeitete Datenkategorien</h2>
      <ul>
        <li><strong>Stammdaten:</strong> Name, E-Mail, Telefon (von Mandanten/Endkunden, sofern eingegeben)</li>
        <li><strong>Vertragsdaten:</strong> Buchungsverhältnis, Tarif, Zahlungsstatus</li>
        <li><strong>Nutzungsdaten:</strong> Login-Zeitpunkte, IP-Adresse (kurzzeitig zur Session-Validierung)</li>
        <li><strong>Inhaltliche Daten:</strong> Eingegebene Lead-Informationen, Angebotsdaten, Nachrichten</li>
        <li><strong>Kommunikationsdaten:</strong> E-Mail-Versand-Metadaten (Empfänger, Zeitpunkt, Status)</li>
      </ul>

      <h2>3. Zwecke und Rechtsgrundlagen</h2>
      <ul>
        <li>Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO) — Bereitstellung der SaaS-Plattform</li>
        <li>Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) — Sicherheit, Missbrauchsverhinderung, technische Optimierung</li>
        <li>Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) — sofern explizit erteilt (z.B. Cookie-Einwilligung)</li>
      </ul>

      <h2>4. Eingesetzte Dienste</h2>
      <h3>Hosting</h3>
      <p>{BRAND.name} wird auf Infrastruktur von Emergent gehostet. Server-Standort: Europäische Union, soweit verfügbar.</p>

      <h3>Authentifizierung — Google Login</h3>
      <p>
        Für die Anmeldung verwenden wir Google OAuth (Anbieter: Google Ireland Limited).
        Es werden ausschließlich die für die Anmeldung notwendigen Profildaten (Name, E-Mail) übermittelt.
      </p>

      <h3>Zahlungsabwicklung — Stripe</h3>
      <p>
        Für die Abrechnung von Abonnements verwenden wir Stripe Payments Europe Ltd.
        Zahlungsdaten werden direkt an Stripe übermittelt und nicht auf unseren Servern gespeichert.
      </p>

      <h3>E-Mail-Versand — IONOS SMTP</h3>
      <p>
        Transaktionale E-Mails (Angebote, Follow-ups, Einladungen) werden über IONOS SE versendet.
        Empfänger- und Versanddaten werden zur Nachweisbarkeit (Audit-Log) gespeichert.
      </p>

      <h2>5. Geplante Analyse- und Marketingdienste</h2>
      <p>
        Wir planen, künftig die folgenden Dienste für Reichweitenmessung, Conversion-Tracking und
        Marketing einzusetzen. <strong>Aktuell sind diese Dienste nicht im SaaS-Frontend von {BRAND.name} aktiv eingebunden</strong>
        und es werden keine entsprechenden Daten an die Anbieter übermittelt.
      </p>
      <ul>
        <li>
          <strong>Google Analytics 4</strong> (Anbieter: Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Irland)
          — Reichweitenanalyse, Nutzungsstatistiken.
        </li>
        <li>
          <strong>Google Ads Conversion-Tracking</strong> (Anbieter: Google Ireland Ltd.)
          — Messung des Erfolgs von Werbekampagnen.
        </li>
        <li>
          <strong>Google Tag Manager</strong> (Anbieter: Google Ireland Ltd.)
          — Container zur Verwaltung weiterer Tags; selbst keine eigenständige Datenerhebung.
        </li>
        <li>
          <strong>Meta Pixel / Meta Ads / Facebook &amp; Instagram Ads</strong> (Anbieter: Meta Platforms Ireland Ltd., 4 Grand Canal Square, Dublin 2, Irland)
          — Conversion-Tracking, Custom Audiences, Re-Targeting auf Facebook und Instagram.
        </li>
      </ul>
      <p>
        Sollten diese Dienste künftig aktiviert werden, erfolgt die Einbindung ausschließlich auf Grundlage
        Ihrer ausdrücklichen Einwilligung gemäß § 25 Abs. 1 TTDSG i.V.m. Art. 6 Abs. 1 lit. a DSGVO
        über ein erweitertes Consent-Banner. Eine erteilte Einwilligung können Sie jederzeit mit Wirkung
        für die Zukunft widerrufen. Bei einer Aktivierung kann es zur Übermittlung personenbezogener
        Daten in Drittländer (insbesondere in die USA) kommen; die rechtlichen Grundlagen (z.B.
        EU-US Data Privacy Framework, Standardvertragsklauseln) werden zum Zeitpunkt der Aktivierung
        in dieser Datenschutzerklärung ergänzt.
      </p>

      <h2>6. Cookies und lokale Speicherung</h2>
      <p>
        {BRAND.name} verwendet aktuell ausschließlich technisch notwendige Cookies bzw. localStorage-Einträge
        (Session-Token für die Anmeldung, Cookie-Consent-Speicherung). Es werden derzeit keine Analyse- oder Marketing-Cookies eingesetzt.
        Details siehe <a href="/cookies">Cookie-Richtlinie</a>.
      </p>

      <h2>7. Speicherdauer</h2>
      <p>
        Personenbezogene Daten werden so lange gespeichert, wie sie für die Vertragsdurchführung erforderlich sind,
        längstens jedoch im Rahmen der gesetzlichen Aufbewahrungsfristen (i.d.R. 10 Jahre bei steuerrelevanten Daten).
      </p>

      <h2>8. Ihre Rechte</h2>
      <p>Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
      <ul>
        <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
        <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
        <li>Recht auf Löschung (Art. 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        <li>Recht auf Widerruf einer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
      </ul>
      <p>
        Zur Ausübung dieser Rechte wenden Sie sich bitte an: <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>.
      </p>

      <h2>9. Beschwerderecht bei der Aufsichtsbehörde</h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
        Zuständige Aufsichtsbehörde für den Sitz des Betreibers ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach.
      </p>

      <h2>10. Follow-up-Abmeldung</h2>
      <p>
        Jede automatische Follow-up-Nachricht enthält einen Abmelde-Link. Mit einem Klick wird der Versand weiterer
        Follow-up-Nachrichten zu diesem Angebot dauerhaft eingestellt — ohne Login oder Anfrage an uns.
      </p>
    </LegalPageLayout>
  );
}
